import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		textField: {
			width: "100%",
		},
		chipContainer: {
			cursor: "pointer",
		},
		chip: {
			margin: 3
		}
	} satisfies Record<string, CSSObject>);
};